module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-promo/btn-spin@3x.png
// module id = 219
// module chunks = 0